import "./Tenants.module.css";
import StudioCommandHeader from "@/reusable_sections/Header";
import RentersRoadmap from "./sections/RentersRoadmap";
import TenantFaq from "./sections/TenantFaq";
import Footer from "@/reusable_sections/Footer";
export default function TenantsPage() {
  return <div>
      <StudioCommandHeader />
      <RentersRoadmap />
      <TenantFaq />
      <Footer />
    </div>;
}